import React, { FC } from 'react';
import clsx from 'clsx';
import { cleanString } from 'helpers/utils/util';
import { ExtensionTagConfig } from 'types/entity/product';
import { useProjectSettings } from 'frontastic';

export interface ColoredTagTypes {
  label?: string;
  dataFfid?: string;
  isSale?: boolean;
  inline?: boolean;
}

function getTagColor(tags: ExtensionTagConfig | null, searchValue: string): string | undefined {
  const value = searchValue?.trim()?.toLowerCase();

  const primaryValues = tags?.EXTENSION_PRIMARY_TAG_VALUES?.split(',').map((v) => v?.trim()?.toLowerCase());
  const secondaryValues = tags?.EXTENSION_SECONDARY_TAG_VALUES?.split(',').map((v) => v?.trim()?.toLowerCase());
  const tertiaryValues = tags?.EXTENSION_TERTIARY_TAG_VALUES?.split(',').map((v) => v?.trim()?.toLowerCase());

  if (primaryValues?.includes(value)) {
    return tags?.EXTENSION_PRIMARY_TAG_COLOR;
  }

  if (secondaryValues?.includes(value)) {
    return tags?.EXTENSION_SECONDARY_TAG_COLOR;
  }

  if (tertiaryValues?.includes(value)) {
    return tags?.EXTENSION_TERTIARY_TAG_COLOR;
  }

  // Default color if not found
  return tags?.EXTENSION_DEFAULT_TAG_COLOR;
}

const ColoredTag: FC<ColoredTagTypes> = ({ label, dataFfid, isSale = false, inline = false }) => {
  const { projectSettings } = useProjectSettings();

  const tagConfig = projectSettings?.customTags?.[0] ?? null;

  const displayLabel = isSale ? tagConfig?.saleTag : label;

  if (typeof displayLabel !== 'string' || !displayLabel.trim()) {
    return null;
  }

  const backgroundColor = isSale ? tagConfig?.saleTagColor : getTagColor(tagConfig, displayLabel);

  const defaultFfid = `lbl-${cleanString(displayLabel)}`;

  return (
    <span
      className={clsx(
        'inline-flex w-fit items-center justify-center text-center',
        'font-bold',
        'text-white',
        'text-10 uppercase',
        'leading-none',
        'max-w-96 md:max-w-170',
        inline ? ['px-4 py-1', 'rounded-md', 'h-15'] : ['px-8 py-2', 'rounded-full', 'sm:text-14', 'h-18 sm:h-24'],
      )}
      style={{ backgroundColor}}
    >
      <span
        className="flex items-center justify-center min-w-0 truncate"
        aria-label={displayLabel}
        data-ffid={dataFfid ?? defaultFfid}
        title={displayLabel}
      >
        {displayLabel} 
      </span>
    </span>
  );
};

export default ColoredTag;
